module.exports = __webpack_public_path__ + "assets/img/vue_template_style.393281c6.jpg";